import decimal2hex from './decimal-to-hex';

const rgb2hex = ({ red, green, blue, alpha }) => {
  const redInHex = decimal2hex(Math.round(255 * red));
  const greenInHex = decimal2hex(Math.round(255 * green));
  const blueInHex = decimal2hex(Math.round(255 * blue));
  const alphaInHex = alpha < 1 ? decimal2hex(Math.round(255 * alpha)) : '';

  return `${redInHex}${greenInHex}${blueInHex}${alphaInHex}`;
};

export default rgb2hex;
